export default "__VITE_ASSET__CumvuUr1__"